<template>
  <div class="pricing-page">
    <v-container :class="{'py-10': $vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl, 'py-6': $vuetify.breakpoint.sm || $vuetify.breakpoint.xs}">
      <h1 :class="{'text-center mb-6': $vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl, 'text-center mb-4 mt-4': $vuetify.breakpoint.sm || $vuetify.breakpoint.xs}">Ціни на послуги</h1>
      <h2 :class="{'text-center mb-10': $vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl, 'text-center mb-6': $vuetify.breakpoint.sm || $vuetify.breakpoint.xs}">(через ЕнергоБали)</h2>
      
      <!-- Desktop версия таблицы (отображается только на md и больше) -->
      <v-simple-table class="pricing-table hidden-sm-and-down">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center primary white--text py-4">Електроенергія</th>
              <th class="text-center info white--text py-4">Холодна вода та водовідведення</th>
              <th class="text-center warning white--text py-4">Природний газ</th>
              <th class="text-center error white--text py-4">Теплопостачання</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-center py-2">АТ «Харківенергозбут»</td>
              <td class="text-center py-2">КП «Харківводоканал»</td>
              <td class="text-center py-2">АТ «Нафтогаз України» + Оператор ГРМ</td>
              <td class="text-center py-2">КП «Харківські теплові мережі»</td>
            </tr>
            <tr>
              <td class="text-center py-3">1 ЕнергоБал = 1 кВт·год</td>
              <td class="text-center py-3">1 ВодноБал = 1 м³ (вода + водовідведення)</td>
              <td class="text-center py-3">1 ГазБал = 1 м³ газу</td>
              <td class="text-center py-3">1 ТеплоБал = 1 Гкал тепла</td>
            </tr>
            <tr>
              <td class="text-center py-3">Ціна: <strong>4,32 ₴</strong> за 1 ЕнергоБал</td>
              <td class="text-center py-3">Ціна: <strong>24,51 ₴</strong> за 1 ВодноБал<br>(16,03 ₴ водопостачання + 8,48 ₴ водовідведення)</td>
              <td class="text-center py-3">Ціна: <strong>8,50 ₴</strong> за 1 ГазБал</td>
              <td class="text-center py-3">Ціна: <strong>2 200 ₴</strong> за 1 ТеплоБал</td>
            </tr>
            <tr>
              <td class="text-center py-3">Мінімальне поповнення: 10 ЕнергоБалів (43,20 ₴)</td>
              <td class="text-center py-3">Мінімальне поповнення: 1 ВодноБал (24,51 ₴)</td>
              <td class="text-center py-3">Мінімальне поповнення: 10 ГазБалів (85,00 ₴)</td>
              <td class="text-center py-3">Мінімальне поповнення: 0,1 ТеплоБала (220 ₴)</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      
      <!-- Мобильная версия (отображается только на xs и sm) -->
      <div class="hidden-md-and-up">
        <v-row class="mx-4 mt-xs-4">
          <v-col cols="12">
            <v-card class="mb-6 rounded-lg" elevation="3">
              <v-card-title class="primary white--text py-5 text-center justify-center">Електроенергія</v-card-title>
              <v-card-text class="px-4 py-4">
                <div class="text-center py-2">АТ «Харківенергозбут»</div>
                <div class="text-center py-3">1 ЕнергоБал = 1 кВт·год</div>
                <div class="text-center py-3">Ціна: <strong>4,32 ₴</strong> за 1 ЕнергоБал</div>
                <div class="text-center py-3">Мінімальне поповнення: 10 ЕнергоБалів (43,20 ₴)</div>
              </v-card-text>
            </v-card>
          </v-col>
          
          <v-col cols="12">
            <v-card class="mb-6 rounded-lg" elevation="3">
              <v-card-title class="info white--text py-5 text-center justify-center">Холодна вода та водовідведення</v-card-title>
              <v-card-text class="px-4 py-4">
                <div class="text-center py-2">КП «Харківводоканал»</div>
                <div class="text-center py-3">1 ВодноБал = 1 м³ (вода + водовідведення)</div>
                <div class="text-center py-3">Ціна: <strong>24,51 ₴</strong> за 1 ВодноБал<br>(16,03 ₴ водопостачання + 8,48 ₴ водовідведення)</div>
                <div class="text-center py-3">Мінімальне поповнення: 1 ВодноБал (24,51 ₴)</div>
              </v-card-text>
            </v-card>
          </v-col>
          
          <v-col cols="12">
            <v-card class="mb-6 rounded-lg" elevation="3">
              <v-card-title class="warning white--text py-5 text-center justify-center">Природний газ</v-card-title>
              <v-card-text class="px-4 py-4">
                <div class="text-center py-2">АТ «Нафтогаз України» + Оператор ГРМ</div>
                <div class="text-center py-3">1 ГазБал = 1 м³ газу</div>
                <div class="text-center py-3">Ціна: <strong>8,50 ₴</strong> за 1 ГазБал</div>
                <div class="text-center py-3">Мінімальне поповнення: 10 ГазБалів (85,00 ₴)</div>
              </v-card-text>
            </v-card>
          </v-col>
          
          <v-col cols="12">
            <v-card class="mb-6 rounded-lg" elevation="3">
              <v-card-title class="error white--text py-5 text-center justify-center">Теплопостачання</v-card-title>
              <v-card-text class="px-4 py-4">
                <div class="text-center py-2">КП «Харківські теплові мережі»</div>
                <div class="text-center py-3">1 ТеплоБал = 1 Гкал тепла</div>
                <div class="text-center py-3">Ціна: <strong>2 200 ₴</strong> за 1 ТеплоБал</div>
                <div class="text-center py-3">Мінімальне поповнення: 0,1 ТеплоБала (220 ₴)</div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
      
      <v-row :class="{'mt-12 mb-6': $vuetify.breakpoint.md || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl, 'mt-8 mb-4': $vuetify.breakpoint.sm || $vuetify.breakpoint.xs}">
        <v-col cols="12">
          <v-card class="mx-auto py-4" elevation="2">
            <v-card-text class="text-center">
              <p class="mb-4">Для отримання додаткової інформації щодо тарифів та послуг, будь ласка, зв'яжіться з нами.</p>
            </v-card-text>
            <v-card-actions class="justify-center pb-4">
              <v-row justify="center">
                <v-col cols="12" class="text-center mb-4">
                  <v-btn 
                    large 
                    outlined 
                    rounded 
                    :to="form" 
                    class="yellow_btn px-12 py-4 action-btn"
                  >
                    <span class="yellow_btn_text">Залишити заявку</span>
                  </v-btn>
                </v-col>
                
                <v-col cols="12" class="text-center">
                  <v-btn 
                    large 
                    outlined 
                    rounded 
                    to="/oferta"
                    class="blue_btn px-12 py-4 action-btn"
                  >
                    <v-icon left>mdi-file-pdf-box</v-icon>
                    <span class="blue_btn_text">Переглянути оферту</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "Pricing",
  data: () => ({
    form: "/form"
  })
}
</script>

<style scoped>
h1 {
  font-family: 'Artega Sans', sans-serif;
  color: #0F0C56;
  font-size: 36px;
  font-weight: 700;
  line-height: 1.2;
}

h2 {
  font-family: 'Artega Sans', sans-serif;
  color: #0F0C56;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;
}

.pricing-list {
  list-style-type: none;
  padding-left: 0;
}

.pricing-list li {
  margin-bottom: 12px;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  line-height: 1.5;
}

.yellow_btn {
  background: transparent;
  border: 1px solid #0F0C56;
}

.yellow_btn:hover {
  border: 1px solid #FCBD22;
  background: linear-gradient(92.46deg, #FBA802 16.53%, #FCBD22 55.38%, #FBCD39 98.62%) !important;
  box-shadow: 0px 0px 7px 4px rgba(252, 170, 6, 0.3);
}

.yellow_btn_text {
  font-family: 'Artega Sans', sans-serif;
  color: #0F0C56;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.22;
}

.yellow_btn:hover .yellow_btn_text {
  color: #fff;
}

.blue_btn {
  background: transparent;
  border: 1px solid #0F0C56;
}

.blue_btn:hover {
  border: 1px solid #0F0C56;
  background: linear-gradient(92.46deg, #0F0C56 16.53%, #2C288A 55.38%, #3F3BB5 98.62%) !important;
  box-shadow: 0px 0px 7px 4px rgba(15, 12, 86, 0.3);
}

.blue_btn_text {
  font-family: 'Artega Sans', sans-serif;
  color: #0F0C56;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.22;
}

.blue_btn:hover .blue_btn_text {
  color: #fff;
}

.v-card-title {
  font-family: 'Artega Sans', sans-serif;
  font-weight: 600;
}

.action-btn {
  width: 280px;
  max-width: 100%;
}
</style>
